<template>
    <div class="connectionContainer">
            <div class="connectionHeader">
                <div class="modal_title"> 配送料</div>
            </div>
            <div class="connectionContents">
                <div class="modal_body">
                    <div class="modal_form">
                        <div class="modal_input">
                            <label>ID</label>
                            <input type="text" placeholder="ID" v-model="delivery_size.id">
                        </div>
                        <div class="modal_input">
                            <label>配送タイプ</label>
                            <input type="text" placeholder="配送タイプ" v-model="delivery_size.text">
                        </div>
                        <div class="modal_input">
                            <label>配送料</label>
                            <input type="text" placeholder="配送料" v-model="delivery_size.price">
                        </div>
                        <div class="modal_input">
                            <label>FBA配送料</label>
                            <input type="text" placeholder="FBA配送料" v-model="delivery_size.fba_price">
                        </div>
                    </div>
                    <div class="modal_submit">
                        <template v-if="createMode">
                            <Button width="100px" @click="createDeliverySize">追加</Button>
                        </template>
                        <template v-else>
                            
                            <Button width="100px" @click="updateDeliverySize">更新</Button>
                        </template>
                    </div>
                </div>
            </div>
            <div class="connectionFooter">
                <template v-if="! createMode">
                    <Button class="btn deleteBtn" @click="openDeleteModal">削除</Button>
                </template>
            </div>
            <modal name="deleteModal" :draggable="false" :resizable="false" width="60%" height="200px">
                <DeleteModal @canceled="closeDeleteModal" @deleted="deleteDeliverySize"/>
            </modal>
        </div>
    <!-- </div> -->
</template>

<script>

import DeleteModal from './DeleteModal.vue';

export default {
    name: 'DeliverySizeModal',
    components: {
        DeleteModal,
    },
    props: {
        createMode: Boolean,
        deliverySizeId: Number,
    },
    data() {
        return {
            delivery_size: {}
        }
    },
    mounted: function() {
        if (this.deliverySizeId !== null) {
            this.getDeliverySize();
        }
    },
    methods: {
        getDeliverySize: function() {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/deliverySizes/" + this.deliverySizeId)
            .then((res) => {
                this.delivery_size = res.data;
            }).catch(() => {
            }).finally(() => {
                this.$store.dispatch("loading", false);
            });
        },
        createDeliverySize: function() {
            this.$store.dispatch("loading", true);
            const data = {
                id: this.delivery_size.id,
                text: this.delivery_size.text,
                price: this.delivery_size.price,
                fba_price: this.delivery_size.fba_price,
            }; 
            this.axios.post("/api/deliverySizes/", data)
            .then(() => {
                this.modalClose();
            }).catch(() => {
            }).finally(() => {
                this.$store.dispatch("loading", false);
            });
        },
        updateDeliverySize: function() {
            this.$store.dispatch("loading", true);
            const data = {
                id: this.delivery_size.id,
                text: this.delivery_size.text,
                price: this.delivery_size.price,
                fba_price: this.delivery_size.fba_price,
            }; 
            this.axios.put("/api/deliverySizes/" + this.deliverySizeId, data)
            .then(() => {
                this.modalClose();
            }).catch(() => {
            }).finally(() => {
                this.$store.dispatch("loading", false);
            });
        },
        deleteDeliverySize: function() {
            this.$store.dispatch("loading", true);
            this.axios.delete("/api/deliverySizes/" + this.deliverySizeId)
            .then(() => {
                this.modalClose();
            }).catch(() => {
            }).finally(() => {
                this.$store.dispatch("loading", false);
            });
        },
        openDeleteModal() {
            this.$modal.show('deleteModal');
        },
        closeDeleteModal() {
            this.$modal.hide('deleteModal');
        },
        modalClose() {
            this.$emit('modalClosed');
            this.$store.dispatch("successful", false);
        }
    },
    watch: {
    }
}
</script>

<style scoped lang="sass">
.connectionContainer
    height: 100%
    width: 100%
    margin: 0
    padding: 10px
    display: inline-grid
    grid-template-rows: 40px 1fr 40px
    grid-row-gap: 10px
    .cancelBtn
        width: 100px
        background-color: #ccc
        border: 1px solid #ccc
    .deleteBtn
        width: 100px
        background-color: #ff5252
        border: 1px solid #ff5252
    .connectionHeader
        display: flex
        align-items: center
        font-size: 1.5rem
        justify-content: center
        .modal_title
            font-size: 1.8rem
    .connectionContents
        display: inline-grid
        overflow: auto
        .modal_form
            padding: 32px
            .modal_input
                margin-bottom: 24px
                display: flex
                justify-content: start
                align-items: center 
                label
                    font-size: 1.4rem
                    width: 30%

                input
                    border: 1px solid $grayColor
                    width: 70%
                    padding: 10px
                    text-align: left
                    width: 100%
                    &:focus
                        outline: 2px solid $mainColor
        .modal_submit
            display: flex
            justify-content: center
    .modal_delete
        padding: 24px
        p
            font-size: 1.6rem
        .delete_btns
            margin-top: 40px
            display: flex
            justify-content: space-evenly
        
    .connectionFooter
        display: flex
        justify-content: start
</style>
